module.exports = __webpack_public_path__ + "static/media/bruker_dark.3ad67694.png";